import Banner from '../components/Banner.js';
import Effortly from '../components/Effortly.js';
import SecureForMe from '../components/SecureForMe.js';
import Contact from '../components/Contact.js';

function Home() {
    return (
        <>   
        <Banner />
        <Effortly />
        <SecureForMe />
        <Contact />
        </>
  );
}

export default Home;